export const COOKIE_KEY = {
  deviceId: 'did',
  userId: 'uid',
  customerCategory: 'cusCat',
  useCase: 'useCase',
  cookieAccepted: 'cookie_accepted',
  oAuthReg: 'oauth_reg',
  oAuthLog: 'oauth_log',
  sendMarketingEmail: 'send_marketing_email',
  showQuiz: 'show_survey',
  abTest: 'ab_test',
  language: 'lang',
  projectName: 'pn',
};

export type CookieKey = (typeof COOKIE_KEY)[keyof typeof COOKIE_KEY];
